import { Box, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import userAccessReviewImage from "./user-access-review.svg";

const UserAccessReview = () => {
  const colors = useColors();

  return (
    <Box>
      <Box
        component="img"
        src={userAccessReviewImage}
        width={"100%"}
        height="auto"
        style={{
          filter: "blur(5px)",
          color: "transparent",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "40vh",
          left: "50vw",
          transform: "translate(-50%, -50%)",
          backgroundColor: colors.modal_bg,
          borderRadius: "10px",
          padding: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          width: "37em",
          boxShadow: "0 1px 3px 3px " + colors.primary_48percent,
        }}
      >
        <Typography variant="h6">User Access Review Coming Soon</Typography>
        <Typography variant="body1">
          User Access Review will be available in the next quarter, once we have
          collected enough data to give you meaningful insights.
        </Typography>
      </Box>
    </Box>
  );
};

export default UserAccessReview;
